










import { defineComponent } from '@nuxtjs/composition-api';
import { SCHEMA_ITEM_PROP, SCHEMA_ITEM_TYPE } from '~/constants/seo';
import ReviewMetaSchema from '~/components/atoms/Review/ReviewMetaSchema/ReviewMetaSchema.vue';

export default defineComponent({
  name: 'AggregateReviewSchema',
  components: {
    ReviewMetaSchema,
  },
  props: {
    reviewsCount: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      SCHEMA_ITEM_PROP,
      SCHEMA_ITEM_TYPE,
    };
  },
});
